import { combineReducers } from 'redux';
import changeState from './reducers/ChangeState';
import userReducer from './reducers/UserReducer';
import BranchReducer from './reducers/BranchReducer';
import ticketReducer from './reducers/TicketReducer';
import notificationReducer from './reducers/NotificationReducer';
import offlineReducer from './offline/offlineSlice';

const rootReducer = combineReducers({
  changeState: changeState,
  userReducer: userReducer,
  BranchReducer: BranchReducer,
  ticketReducer: ticketReducer,
  notificationReducer: notificationReducer,
  offline: offlineReducer,
});

export default rootReducer;
